import styled, { css } from 'styled-components';

import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import SubscriptionTitle, { TSubscriptionTitleProps } from '@r1-frontend/ui-react/organisms/TariffSubscription/Title/Title';

const StyledSubscriptionTitle = styled(SubscriptionTitle)<TSubscriptionTitleProps>`
    display: block;

    ${Svg} {
        float: left;
        cursor: pointer;

        ${({ iconSize = 16 }) => iconSize === 16
                ? css`
                    margin: 4px 4px 0 0;
                `
                : css`
                    margin: 4px 6px 0 0;
                `
        }
    }
`;

export default StyledSubscriptionTitle;
